import * as React from "react";
function XlIcon() {
    return React.createElement("path", { d: "M20.423 30.1303L11 20.7072L12.4743 19.2329L20.423 27.1838L28.3717 19.2329L29.8461 20.7072L20.423 30.1303ZM20.423 19.8974L11 10.4743L12.4743 9L20.423 16.9509L28.3717 9L29.8461 10.4743L20.423 19.8974Z", fill: "currentColor" });
}
export default XlIcon;
//# sourceMappingURL=Xl.js.map